import EmployeeList from '@/pages/employees/EmployeeList';
import EmployeeDetail from '@/pages/employees/EmployeeDetail';
import PhoneList from '@/pages/phones/PhoneList';
import PhoneDetail from '@/pages/phones/PhoneDetail';
import DepartmentList from '@/pages/departments/DepartmentList';
import DepartmentDetail from '@/pages/departments/DepartmentDetail';
import StyleList from '@/pages/styles/StyleList';
import StyleDetail from '@/pages/styles/StyleDetail';
import StatusList from '@/pages/statuses/StatusList';
import StatusDetail from '@/pages/statuses/StatusDetail';
import AnnounceList from '@/pages/announces/AnnounceList';
import AnnounceDetail from '@/pages/announces/AnnounceDetail';
import ActPlan from '@/pages/ActPlan';
import Plan from '@/pages/PlanRegistry';
import Profile from '@/pages/Profile';
import MyGroupList from '@/pages/myGroup/MyGroupList';
import MyGroupDetail from '@/pages/myGroup/MyGroupDetail';
import EmployeeMyGroupDetail from '@/pages/myGroup/EmployeeMyGroupDetail';
import SignIn from '@/pages/SignIn';
import AppShell from '@/pages/AppShell';
import Company from '@/pages/company/Company';
import URL from '@/common/routes/Url';
import Gate from '@/components/appShell/Gate';
import { Role } from '@/common/constants';
import Error from '@/pages/Error';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import HistoryExport from '@/pages/history/HistoryExport';
import TenantList from '@/pages/tenants/TenantList';
import TenantDetail from '@/pages/tenants/TenantDetail';
import HomePage from '@/pages/HomePage';
import Home from '@/pages/home/Home';
import Privacy from '@/pages/home/Privacy';
import Sct from '@/pages/home/Sct';
import Overview from '@/pages/home/Overview';

const Routes = [
  {
    errorElement: <Error />,
  },
  {
    element: <AppShell />,
    children: [
      {
        index: true,
        path: URL.actPlan,
        element: <ActPlan />,
      },
      {
        path: `${URL.plan}/:id`,
        element: <Plan />,
      },
      {
        path: URL.myGroups,
        element: <MyGroupList />,
      },
      {
        path: `${URL.myGroups}/add`,
        element: <MyGroupDetail />,
      },
      {
        path: `${URL.myGroups}/:id`,
        element: <MyGroupDetail />,
      },
      {
        path: `${URL.employeeMyGroups}/:id`,
        element: <EmployeeMyGroupDetail />,
      },
      {
        path: `${URL.historyExport}`,
        element: <HistoryExport />,
      },
      {
        path: URL.actPlan,
        element: <Gate role={Role.管理者} />,
        children: [
          {
            path: URL.company,
            element: <Company />,
          },
          {
            path: URL.statuses,
            element: <StatusList />,
          },
          {
            path: `${URL.statuses}/add`,
            element: <StatusDetail />,
          },
          {
            path: `${URL.statuses}/:id`,
            element: <StatusDetail />,
          },
          {
            path: URL.styles,
            element: <StyleList />,
          },
          {
            path: `${URL.styles}/add`,
            element: <StyleDetail />,
          },
          {
            path: `${URL.styles}/:id`,
            element: <StyleDetail />,
          },
          {
            path: URL.phones,
            element: <PhoneList />,
          },
          {
            path: `${URL.phones}/add`,
            element: <PhoneDetail />,
          },
          {
            path: `${URL.phones}/:id`,
            element: <PhoneDetail />,
          },
          {
            path: URL.employees,
            element: <EmployeeList />,
          },
          {
            path: `${URL.employees}/add`,
            element: <EmployeeDetail />,
          },
          {
            path: `${URL.employees}/:id`,
            element: <EmployeeDetail />,
          },
          {
            path: URL.departments,
            element: <DepartmentList />,
          },
          {
            path: `${URL.departments}/add`,
            element: <DepartmentDetail />,
          },
          {
            path: `${URL.departments}/:id`,
            element: <DepartmentDetail />,
          },
        ],
      },
      {
        element: <Gate role={Role.アナウンス} />,
        children: [
          {
            path: URL.announces,
            element: <AnnounceList />,
          },
          {
            path: `${URL.announces}/add`,
            element: <AnnounceDetail />,
          },
          {
            path: `${URL.announces}/:id`,
            element: <AnnounceDetail />,
          },
        ],
      },
      {
        path: `${URL.profile}`,
        element: <Profile />,
      },
    ],
  },
  {
    path: URL.homePage,
    element: <Home />,
  },
  {
    path: URL.privacy,
    element: <Privacy />,
  },
  {
    path: URL.sct,
    element: <Sct />,
  },
  {
    path: URL.overview,
    element: <Overview />,
  },
  {
    path: URL.signin,
    element: <SignIn />,
  },
  {
    path: URL.forgotPassword,
    element: <ForgotPassword />,
  },
  {
    path: URL.resetPassword,
    element: <ResetPassword />,
  },
  {
    path: URL.tenants,
    element: <TenantList />,
  },
  {
    path: `${URL.tenants}/add`,
    element: <TenantDetail />,
  },
  {
    path: `${URL.tenants}/:id`,
    element: <TenantDetail />,
  },
];

export default Routes;
